import { render, staticRenderFns } from "./SalonDatePicker.vue?vue&type=template&id=3f22a2be&scoped=true&"
import script from "./SalonDatePicker.vue?vue&type=script&lang=js&"
export * from "./SalonDatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f22a2be",
  null
  
)

export default component.exports